import { getToken, handleResponse, nextJsonApi } from '@/API/core';

const userCompanies = {
  getCompaniesBasedOnUserId: async (userId: string) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get(`/user-companies/${userId}/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  updateUserCompanies: async (userId: string, companies: string[]) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.put(
        `/user-companies/${userId}/update`,
        {
          companies: companies,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default userCompanies;
